import { isNumberLike } from "@/utils";
import { multiply, fmoney } from "@/utils/count";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("constant", [
      "businessTypes",
      "countryList",
      "invoiceTypeList",
      "applymentStatusList",
      "orderStatusList",
      "refundStatusList",
      "payTypes",
      "orderTypeList",
      "creditStatusList",
      "adjustmentStatusList",
      "applicantPositionOptions",
      "entityTypes",
      "riskRatingTypes",
      "stepStatusList",
      "renewStatusList",
      "engagementStatusList",
      "engagementControlStatusList",
      "engagementCompanyTypeList",
      "clientCodeStatusList",
      "introducedByList",
      "ownershipTypeOptions",
      "ownershipRoleOptions",
      "invoiceItemCategoryList",
      "protocolTypeList",
      "transactionTypeList",
      "marketingEmailPushTypeList",
      "campaignPushStatusList",
    ]),
    ...mapState("currency", ["currencyList", "currencyMap"]),
  },
  methods: {
    // 将小数转成百分比
    percentageFormat(val) {
      if (isNumberLike(val)) {
        const newVal = multiply(val, 100);
        return `${Number(newVal)}%`;
      } else {
        return "";
      }
    },
    // 获取货币符号
    currencySymbolFormat(currency) {
      const symbol = this.currencyMap[currency] || currency || "";
      return symbol;
    },
    // 传入货币code、金额，返回货币符号+千分位金额
    currencyAndAmountFormat(currency, price) {
      if (!isNumberLike(price)) return "";
      // price为数字或数字字符串
      const symbol = this.currencyMap[currency] || currency || "";
      // 千分位
      const amount = fmoney(price, 2);
      return `${symbol}${amount}`;
    },
    // 传入货币符号、金额，返回货币符号+千分位金额
    symbolAndAmountFormat(symbol, price) {
      if (!isNumberLike(price)) return "";
      // 千分位
      const amount = fmoney(price, 2);
      return `${symbol}${amount}`;
    },
    // 格式化用户(复核、业务)姓名
    userNameFormat(user) {
      return (user && (user.nickname || user.username)) || "unassigned";
    },
    // 启用/禁用状态
    enableAndDisableFormat(row, column, cellValue) {
      if (cellValue) {
        return (
          <el-tag type="success" size="samll">
            Enable
          </el-tag>
        );
      } else {
        return (
          <el-tag type="danger" size="samll">
            Disable
          </el-tag>
        );
      }
    },
    // 角色列表格式化
    roleListToStringFormatter(row, column, cellValue) {
      return cellValue.map(i => i.name).join(", ");
    },
    // 国家格式化
    countryFormat(value) {
      const one = this.countryList.find(i => i.value === value);
      return one?.title || "";
    },
    // 单个业务类型格式化
    businessTypeFormat(cellValue) {
      const one = this.businessTypes.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 多个业务类型格式化
    businessTypeListFormat(row, column, cellValue) {
      let titleArr = [];
      this.businessTypes.forEach(item => {
        cellValue.forEach(child => {
          if (item.value === child) {
            titleArr.push(item?.title);
          }
        });
      });
      return titleArr.toString();
    },
    // 发票模板类型格式化
    invoiceTypeFormat(cellValue) {
      const one = this.invoiceTypeList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 发票模板语言格式化
    languageOptionListFormat(row, column, cellValue) {
      const supportLanguageList = this.countryList.find(i => i.value === row.country)?.supportLanguageList || [];
      const one = supportLanguageList.find(ele => ele.value == cellValue);
      return one?.title || "";
    },
    // 发票绑定的银行账号格式化
    bankAccountListFormat(row, column, cellValue) {
      const bankAccountList = row?.bankAccountList || [];
      const tagList = bankAccountList.map(item => item.tag) || [];
      return tagList.join(", ");
    },
    // 订单类型格式化
    orderTypeFormat(cellValue) {
      const one = this.orderTypeList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 订单状态格式化
    orderStatusFormat(cellValue) {
      const one = this.orderStatusList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 后付款状态格式化
    creditStatusFormat(cellValue) {
      const one = this.creditStatusList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 退款状态格式化
    refundStatusFormat(cellValue) {
      const one = this.refundStatusList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 支付类型格式化
    payTypesFormat(cellValue) {
      const one = this.payTypes.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // Quotation(V)补款状态格式化
    adjustmentStatusFormat(cellValue) {
      const one = this.adjustmentStatusList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 申请单角色格式化
    applicantPositionFormat(v) {
      const one = this.applicantPositionOptions.find(i => i.value === v);
      return one?.title || "";
    },
    // 主体类型格式化
    entityTypeFormat(cellValue) {
      const one = this.entityTypes.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 风险评估类型格式化
    riskRatingFormat(cellValue) {
      const one = this.riskRatingTypes.find(i => i.value == cellValue);
      return one?.title || "";
    },
    // 申请状态格式化
    applymentStatusFormat(cellValue, hasBracket = false) {
      const one = this.applymentStatusList.find(i => i.value === cellValue);
      if (hasBracket) {
        return one?.title ? `(${one.title})` : "";
      } else {
        return one?.title || "";
      }
    },
    // 申请步骤状态格式化
    stepStatusFormat(v) {
      const one = this.stepStatusList.find(i => i.value === v.status);
      return one?.title || "";
    },
    // 续约状态格式化
    renewStatusFormat(v) {
      const one = this.renewStatusList.find(i => i.value === v);
      return one?.title || "";
    },
    // engagement 状态格式化
    engagementStatusFormat(cellValue) {
      const one = this.engagementStatusList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // engagement control 状态格式化
    engagementControlStatusFormat(cellValue) {
      const one = this.engagementControlStatusList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // engagement 公司类型列表
    engagementCompanyTypeFormat(cellValue) {
      const one = this.engagementCompanyTypeList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // client Code 状态格式化
    clientCodeStatusFormat(cellValue) {
      const one = this.clientCodeStatusList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // client Code 是否需要佣金
    introducedByFormat(cellValue) {
      const one = this.introducedByList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 申请单角色分配类型格式化
    ownershipTypeFormat(cellValue) {
      const one = this.ownershipTypeOptions.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 申请单角色格式化
    ownershipRoleFormat(cellValue) {
      const one = this.ownershipRoleOptions.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 协议类型格式化
    protocolTypeFormat(value) {
      return this.protocolTypeList.find(i => i.value === value)?.title || "";
    },
    // 发票明细分类格式化
    invoiceItemCategoryFormat(cellValue) {
      const one = this.invoiceItemCategoryList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 交易类型格式化
    transactionTypeFormat(cellValue) {
      const one = this.transactionTypeList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 营销邮件推送方式格式化
    marketingEmailPushTypeFormat(cellValue) {
      const one = this.marketingEmailPushTypeList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 营销邮件推荐状态格式化
    campaignPushStatusFormat(cellValue) {
      const one = this.campaignPushStatusList.find(i => i.value === cellValue);
      return one?.title || "";
    },
    // 拟设公司名称格式化
    proposedCompanyNameFormat(row) {
      if (row.companyName) return [row.companyName];
      if (row.proposedCompanyName) return [row.proposedCompanyName];
      return [row.proposedCompanyName1, row.proposedCompanyName2, row.proposedCompanyName3];
    },
    // 关联的操作(交易)类型
    linkedTransactionFormat(row, column, cellValue) {
      return (
        <div>
          <p>{row.hasRenew ? "Renewal" : ""}</p>
          <p>{row.hasLaterService ? "Supplemental" : ""}</p>
          <p>{row.isRenew ? "Be Renewed" : ""}</p>
          <p>{row.isLaterService ? "Have Supplements" : ""}</p>
        </div>
      );
    },
    // 操作人员(coordinator/checker/auditor)名称格式化
    operatorStaffFormat(row, column, cellValue) {
      return cellValue && (cellValue.nickname || cellValue.username);
    },
    // Client Code 去重，并使用逗号拼接
    clientCodeDeduplicateFormat(list) {
      if (!list?.length) return "";
      return [...new Set(list.map(item => item?.clientCode).filter(code => code != null && code !== "" && code !== undefined))].join(", ");
    },
    // In-charge 去重，并使用逗号拼接
    inChargeDeduplicateFormat(list) {
      if (!list?.length) return "";
      const result = [
        ...new Set(
          list
            .flatMap(item => item.inChargeUsers || [])
            .map(user => user.nickname)
            .filter(name => name && name.trim() !== "" && name !== undefined),
        ),
      ].join(", ");
      return result;
    },
    // Engagement ID 去重，并使用逗号拼接
    engagementIdDeduplicateFormat(list) {
      if (!list?.length) return "";
      return [...new Set(list.map(item => item?.id).filter(ele => ele != null && ele !== "" && ele !== undefined))].join(", ");
    },
    // Billing Party 去重，并使用逗号拼接
    billingPartyDeduplicateFormat(list) {
      if (!list?.length) return "";
      const result = [
        ...new Set(
          list
            .filter(item => item?.billingParty || item?.businessNo) // 确保至少有一个字段有值
            .map(item => {
              const party = item?.billingParty || "";
              const no = item?.businessNo || "";
              return `${party} (${no})`;
            }),
        ),
      ].join(", ");
      return result;
    },
    // supplier 去重，并使用逗号拼接
    supplierAbbrDeduplicateFormat(list) {
      if (!list?.length) return "";
      return [...new Set(list.map(item => item?.abbr).filter(ele => ele != null && ele !== "" && ele !== undefined))].join(", ");
    },
  },
};
